import * as types from './types';
import { Nullable } from 'ts';
import { loginSuccess, logoutSuccess } from 'features/auth/redux/actions';
import { PartnerUser } from '../../users/ts/PartnerUser';

export const profileRequest = ({ useLoading }: { useLoading: boolean } = { useLoading: true }) => ({
  type: types.PROFILE_REQUEST,
  payload: {
    useLoading,
  },
});

export const profileSuccess = (user: PartnerUser) => ({
  type: types.PROFILE_SUCCESS,
  payload: {
    user,
  },
});

export const profileFailed = (error: Nullable<string>) => ({
  type: types.PROFILE_FAILED,
  payload: {
    error,
  },
});

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});

export type UserActions = ReturnType<
  | typeof profileRequest
  | typeof profileSuccess
  | typeof profileFailed
  | typeof clearError
  | typeof logoutSuccess
  | typeof loginSuccess
>;
